module.exports = __webpack_public_path__ + "static/media/04.a5a40990.jpg";